import { render, staticRenderFns } from "./Salaryspecifications.vue?vue&type=template&id=2ed5a083"
import script from "./Salaryspecifications.vue?vue&type=script&lang=js"
export * from "./Salaryspecifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports